<template>
    <div>


        <div v-if="replyHistogram" class="mb-3">
            <h2>Replies Histogram</h2>
            <tweet-histogram :chartData="replyHistogramData"></tweet-histogram>
        </div>


        <!-- Display external links -->
        <div class="mb-3">

            <h2>External Links</h2>

            <h3>In Tweet</h3>
            <ul v-if="externalUrls.length > 0 || mediaEntities.length > 0" class="list-group mb-2 overflow-hidden">

                <li v-for="exturl in externalUrls" class="list-group-item overflow-hidden">
                    <external-link-item :exturl="exturl"></external-link-item>
                </li>


                <li v-for="exturl in mediaEntities" class="list-group-item overflow-hidden">
                    <external-link-item :exturl="exturl"></external-link-item>
                </li>
            </ul>
            <p v-else>No external links</p>
        </div>
        <div class="mb-3">
            <h3>In Replies</h3>

            <ul v-if="repliesExternalUrls.length > 0 || repliesMediaEntities.length > 0" class="list-group mb-2">

                <li v-for="exturl in repliesExternalUrls" class="list-group-item overflow-hidden">
                    <external-link-item :exturl="exturl"></external-link-item>
                </li>

                <li v-for="exturl in repliesMediaEntities" class="list-group-item overflow-hidden">
                    <external-link-item :exturl="exturl"></external-link-item>
                </li>

            </ul>
            <p v-else>No external links</p>

        </div>
    </div>


</template>

<script>

    import {mapState} from 'vuex'
    import ExternalLinkItem from "./ExternalLinkItem";
    import TweetHistogram from "./TweetHistogram";
    const moment = require('moment');
    export default {
        name: "TweetMetadata",
        components: {TweetHistogram, ExternalLinkItem},
        data: function() {
            return {

            }
        },
        props: {
            externalUrls: {
              type: Array,
              default: () => []
            },
            mediaEntities: {
              type: Array,
              default: () => []
            },
            repliesExternalUrls: {
              type: Array,
              default: () => []
            },
            repliesMediaEntities: {
              type: Array,
              default: () => []
            },
        },
        computed: {
            ...mapState(["replyHistogram"]),
          replyHistogramData(){
                if (!this.replyHistogram)
                    return {};

                const histogramData = this.replyHistogram;
                let outputData = [];
                for (const i in histogramData) {
                    const date = moment(histogramData[i][0]);
                    const count = histogramData[i][1];

                    outputData.push({x: date, y: count});

                }

                return {
                    datasets: [
                        {
                            data: outputData,
                            backgroundColor: '#005cbf',
                        }
                    ]
                };

          }
        },
        methods: {
            buildReplyHistogram(){
                var replies_histogram_data = convertHistogramDateStrJsonToJS(this.replyHistogram);
                makeTweetHistogram("#replies_histogram", replies_histogram_data);
            }

        }
    }
</script>

<style scoped>

</style>
